/* eslint-disable no-undef */
import React from "react";
import vectorSvg from '../../../public/Vector.svg';
import vector1Svg from '../../../public/Vector_1.svg';
import vector2Svg from '../../../public/Vector_2.svg';
import vector3Svg from '../../../public/Vector_3.svg';
import vector4Svg from '../../../public/Vector_4.svg';
import icon01Svg from '../../../public/Icon.svg';
import xcloseSvg from '../../../public/x-lg.svg';
import mdrawerSvg from '../../../public/drawer.svg';
import Tooltip from '../../../component/MenuTooltip'

import scheme from '../../../public/scheme.svg';
import { NavLink } from "react-router-dom";
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

class SuperadminDashboard extends React.Component {

  constructor(props) {
    const { location } = props;

    // const dashboardClass = location.pathname.match(/^\/countries/) ? "active" : "";
    super(props);
    this.state = {
      expandSidebar: false
    };
  }

  render() {
    const { expandSidebar } = this.state;
    return (
      <>
        {userData.roles === "administrator" ? <div className="asidebar">
          {expandSidebar ?
            <section className="hovershow" >
              <img src={xcloseSvg} alt="close sidebar" className="right-align" onClick={() => this.setState({ expandSidebar: false })} />
              <div className="d-flex align-items-center justify-content-center">
                <img className="img-center img-width" src={require('../../../public/image_1.png')} alt="" />
              </div>
              <ul className="hide-matter">
                <li><NavLink activeClassName="active" to='/super/portal-statistics'><img src={icon01Svg} alt="icon" /><span>Portal Statistics</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-country'><img src={vectorSvg} alt="Countries" /> <span>Countries</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-users'><img src={vector1Svg} alt="Users" /> <span>Users</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-products'><img src={vector2Svg} alt="Products" /> <span>Products</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-all-events'><img src={vector3Svg} alt="Events" /> <span>Events</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-documents'><img src={vector4Svg} alt="Documents" /> <span>Documents</span></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-schemes'><img src={scheme} className="schvc" alt="Schemes" /> <span>Schemes</span></NavLink></li>
              </ul>
            </section>
            :
            <section className="section1">
              <div className="d-flex align-items-center justify-content-center">
                <img src={mdrawerSvg} alt="close sidebar" className="drawerm" onClick={() => this.setState({ expandSidebar: true })} />
              </div>
              <ul className="show-matter">
                <li><NavLink activeClassName="active" to='/super/portal-statistics'> <Tooltip title="Portal Statistics" id="t-1" className="table-icon"><img src={icon01Svg} alt="Portal Statistics" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-country'><Tooltip title="Countries" id="t-1" className="table-icon"><img src={vectorSvg} alt="Countries" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-users'><Tooltip title="Users" id="t-1" className="table-icon"><img src={vector1Svg} alt="Users" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-products'><Tooltip title="Products" id="t-1" className="table-icon"><img src={vector2Svg} alt="Products" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/view-all-events'><Tooltip title="Events" id="t-1" className="table-icon"><img src={vector3Svg} alt="Events" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-documents'><Tooltip title="Documents" id="t-1" className="table-icon"><img src={vector4Svg} alt="Documents" /></Tooltip></NavLink></li>
                <li><NavLink activeClassName="active" to='/super/all-schemes'><Tooltip title="Schemes" id="t-1" className="table-icon"><img src={scheme} className="schvc" alt="Schemes" /></Tooltip></NavLink></li>

              </ul>
            </section>
          }
        </div> : ''}
        <div className="container-fluid" id="main" >
          {this.props.children}

        </div>
      </>
    );
  }
}
export default SuperadminDashboard;